/**
 * @file separator.tsx
 * @description Разделитель (тонкая выровненная линия для taskbar/menu).
 * NB: для содержательного разделения используем background-сдвиг (No-Line Rule).
 */

import * as React from "react";

import { cn } from "@/lib/utils";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
}

export function Separator({ className, orientation = "horizontal", ...props }: Props) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      data-slot="separator"
      className={cn(
        "bg-outline-variant",
        orientation === "horizontal" ? "h-px w-full" : "w-px h-full",
        className,
      )}
      {...props}
    />
  );
}
